<template>
    <div>
        <card-header title="New Ticket" :subheader="user.first_name + ' ' + user.last_name" icon="fa-life-ring"></card-header>

        <card-toolbar>
            <button @click="openCard('')"><i class="far fa-sign-in-alt"></i>Login</button>

            <template v-slot:right>
                <button class="icon-only" @click="openCard('support-settings')"><i class="far fa-cog"></i></button>
            </template>
        </card-toolbar>

        <card-body subheader toolbar>
            <div class="ml-3 mb-3 reply pl-3 pt-3 pr-3 pb-1">
                <b-form>
                    <b-dropdown id="dropdown-1" text="Select a user to message" variant="outline-secondary" class="mb-2">
                        <b-dropdown-item>Scott Lamont</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item>Michael Scott</b-dropdown-item>
                        <b-dropdown-item>Dwight Shrute</b-dropdown-item>
                    </b-dropdown>

                    <b-form-input placeholder="Subject" class="mb-3 mt-2"></b-form-input>

                    <b-form-textarea id="textarea" v-model="text" placeholder="Enter your message here.." rows="3" max-rows="6"></b-form-textarea>

                    <b-form-checkbox class="mt-2">Also send email to user's email address(es)</b-form-checkbox>

                    <b-form-checkbox class="mt-2">Mark as resolved</b-form-checkbox>

                    <b-button variant="primary" class="mt-3 mr-3 text-right">Send Message</b-button>
                    <b-button variant="outline-danger" class="mt-3 text-right">Cancel</b-button>
                </b-form>

            <div class="mt-3 mb-0 sm-text">{{ text }}</div>
            </div>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardToolbar from "../../components/common/CardToolbar";
    import CardContainer from "../../components/common/CardContainer";
    import CardSubheader from "../../components/common/CardSubheader";
    import DataRow from "../../components/common/DataRow";
    import CardList from "../../components/common/CardList";
    import SupportMessageListItem from "../../components/SupportMessageListItem";
    import SupportTicketMessageSection from "../../components/SupportTicketMessageSection";


    export default {
        components: {DataRow, CardSubheader, CardContainer, CardToolbar, CardBody, CardHeader, CardList, SupportMessageListItem, SupportTicketMessageSection},

        methods: {
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {
                user: {
                    id: 249,
                    first_name: 'Scott',
                    last_name: 'Lamont'
                },
                text: ''
            }
        }
    }
</script>

<style>
    .w-70 {
        width: 70%
    }

    .lighter {
        color: #cccccc
    }

    .progress-title {
        font-size: 14px;
        font-weight: bold;
        text-align: center;
    }

    .progress-bar {
        background-color: #3B84C2;
    }

    button {
        font-size: 13px !important
    }
</style>
